module.exports = __webpack_public_path__ + "static/media/atuação permanente beira rio.a0c45924.jpeg";